import { memo } from 'react'

import {
    Avatar,
    Box,
    CircularProgress,
    ClickAwayListener,
    IconButton,
    makeStyles,
    Tooltip,
    Typography
} from '@material-ui/core'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import VisibilityIcon from '@material-ui/icons/Visibility'

import { SpacedGroup } from 'UI/Components'

import { QuickGuiddeType } from 'app/types'
import { useBoolean } from 'hooks'

const useStyles = makeStyles({
    avatar: {
        width: 40,
        height: 40
    },
    text: {
        fontSize: 14,
        color: 'rgba(9, 12, 16, 0.6)'
    }
})

type Props = {
    isCover: boolean
    isEditMode: boolean
    stepAvatar: string
    audioNote: QuickGuiddeType['audioNote']
    onUpdate: (_isIncludeTranscriptInDoc: boolean) => Promise<unknown>
}

export const StepAudioNote = memo(
    ({ isCover, isEditMode, stepAvatar, audioNote, onUpdate }: Props) => {
        const classes = useStyles()

        const { isIncludeTranscriptInDoc, text } = audioNote || {}

        const loading = useBoolean()
        const showAudioNote = useBoolean(isIncludeTranscriptInDoc)

        // Do not render component at all if no audioNote or it's view mode and audioNote is hidden
        if (!audioNote || (!isEditMode && showAudioNote.isFalse)) return null

        return (
            <ClickAwayListener
                mouseEvent="onMouseDown"
                onClickAway={() => {
                    if (!isEditMode) return

                    if (showAudioNote.isTrue !== isIncludeTranscriptInDoc) {
                        onUpdate(showAudioNote.isTrue)
                    }
                }}
            >
                <Box mb={isCover ? 0 : 2}>
                    {(showAudioNote.isTrue || isEditMode) && text && (
                        <SpacedGroup>
                            <SpacedGroup
                                style={{
                                    opacity: showAudioNote.isFalse ? 0.5 : 1
                                }}
                            >
                                <Avatar src={stepAvatar} className={classes.avatar} />
                                <Typography className={classes.text}>{text}</Typography>
                            </SpacedGroup>
                            {isEditMode && (
                                <>
                                    {loading.isTrue ? (
                                        <Box p={1}>
                                            <CircularProgress size={32} />
                                        </Box>
                                    ) : (
                                        <Tooltip
                                            title={
                                                showAudioNote.isTrue
                                                    ? 'Hide transcript'
                                                    : 'Show transcript'
                                            }
                                        >
                                            <IconButton
                                                onClick={e => {
                                                    e.stopPropagation()
                                                    showAudioNote.toggle()
                                                }}
                                            >
                                                {showAudioNote.isTrue ? (
                                                    <VisibilityOffIcon />
                                                ) : (
                                                    <VisibilityIcon />
                                                )}
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </>
                            )}
                        </SpacedGroup>
                    )}
                </Box>
            </ClickAwayListener>
        )
    }
)
